import React from "react";

// If the page ever crashes, show a way out instead of a blank screen.
// `onReset` should clear any saved data before the page reloads.
export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Page crashed:", error, info);
  }

  handleReset = () => {
    try {
      this.props.onReset?.();
    } catch {}
    window.location.href = window.location.pathname;
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="bg-white shadow-md rounded-xl p-6 max-w-md w-full text-center">
          <h1 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h1>
          <p className="text-gray-600 mb-5">
            Sorry about that. Tap below to reload the page. If you already paid, you won't be charged again.
          </p>
          <button
            onClick={this.handleReset}
            className="w-full p-3 rounded-lg font-semibold bg-[#F20034] text-white hover:bg-red-700"
          >
            Reload and start again
          </button>
          {this.props.supportEmail && (
            <p className="text-gray-500 text-sm mt-4">
              Still stuck? Email{" "}
              <a href={`mailto:${this.props.supportEmail}`} className="text-blue-600 underline break-all">
                {this.props.supportEmail}
              </a>
            </p>
          )}
        </div>
      </div>
    );
  }
}
